import type { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@circle-react-shared/uikit/Form";
import { CORNERS } from "./constants";
import type { ButtonRadiusSelectorType } from "./constants";

interface InputsProps {
  name: string;
  selectedRadius: ButtonRadiusSelectorType;
}

const inputClassName =
  "border-primary bg-primary text-dark group-hover:border-darkest focus:border-darkest group-focus-within:border-darkest w-full appearance-none rounded-lg border px-3 py-2 text-center focus:!outline-none focus:!ring-0";

export const Inputs = ({ selectedRadius, name }: InputsProps) => {
  const { setValue } = useFormContext();

  const handleAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const newValues = {
      border_left_top_radius: value,
      border_left_bottom_radius: value,
      border_right_top_radius: value,
      border_right_bottom_radius: value,
    };

    setValue(name, newValues);
  };

  if (selectedRadius === "all") {
    return (
      <Form.Item
        isFirstChild
        hideBorder
        hideDescription
        name={`${name}.border_left_top_radius`}
        label={null}
      >
        <Form.Input
          label={null}
          name={`${name}.border_left_top_radius`}
          type="number"
          min={0}
          className={inputClassName}
          onChange={handleAllChange}
        />
      </Form.Item>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      {CORNERS.map(corner => (
        <Form.Item
          key={corner}
          isFirstChild
          hideBorder
          hideDescription
          name={`${name}.${corner}`}
          label={null}
        >
          <Form.Input
            label={null}
            name={`${name}.${corner}`}
            type="number"
            min={0}
            className={inputClassName}
          />
        </Form.Item>
      ))}
    </div>
  );
};
